<template>
  <NuxtLayout>
    <HeroHeader :title-visible="false" class="loyalty__Header" stacked-elements>
      <div class="container">
        <div class="loyalty__HeaderInner">
          <Flare v-if="page.logo" :srcset="page.logo" width="200" class="loyalty__HeaderLogo" :alt="page.logo" />

          <h1 v-text="page.title" />
          <p v-if="page.subtitle" v-text="page.subtitle" />

          <div class="loyalty__HeaderButtons">
            <Button type="nuxt-link" :to="link('Registration')" negative medium>{{ $t('join') }}</Button>
            <Button type="nuxt-link" :to="link('Login')" secondary negative medium>{{ $t('login.login') }}</Button>
          </div>
        </div>
      </div>
    </HeroHeader>

    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  // do podataka za page se dolazi preko propa "page"
  const props = defineProps({
    page: {
      type: Object
    }
  })
  
  const { link } = useSetup();

  useHead({
    htmlAttrs: {
      class: 'fixedHeader fixedHeader--WithoutTopPadding',
    },
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_loyalty.scss');
</style>